exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.groups-row[data-v-71e63da6] {\n\theight: 70vh;\n\toverflow-y: hidden;\n}\n.groups-row .col-md-3[data-v-71e63da6] {\n\theight: 100%;\n}\n.groups-row .col-md-3 .groups[data-v-71e63da6] {\n\tmax-height: calc(100% - 90px);\n\toverflow-y: auto;\n}\n.group[data-v-71e63da6] {\n\tfont-weight: 600;\n\tcolor: #90919e;\n}\n.group.active[data-v-71e63da6] {\n\tcolor: #00aef1;\n\tfont-weight: 600;\n\tbox-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.19);\n}\n.view-group[data-v-71e63da6] {\n\toverflow-y: auto;\n\tmax-height: 100%;\n}\n.modal[data-v-71e63da6] {\n\tdisplay: none;\n}\n", ""]);

// exports
